module.exports = __webpack_public_path__ + "img/icon-1.9ef50da4.svg";